import lang from '../../../lang/translator';

const mutations = {
  setProtocol(state, protocolData) {
    state.protocolVuexData = protocolData;
  },
  setProtocolVersion(state, version) {
    state.protocolVersion = version;
  },

};

export default mutations;



// WEBPACK FOOTER //
// ./src/modules/dashboardParent/vuex/mutations.js